import axiosApi from "api/root.api";

export const fetchModelStatus = async (body) => {
  const urlEnd = "/scan/editor/project/v1/scanModelStatus";
  const response = await axiosApi.post(urlEnd, body);
  const result = response.data;
  return result;
};
